// import readXlsxFile from 'read-excel-file';
import React, { Component } from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col } from 'react-bootstrap';
import 'date-fns';
import Spinner from 'react-bootstrap/Spinner';

import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class SalesSummary extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            TotalOPSStore: 0,
            TotalOrderStore: 0,
            TotalStoreAssigend: 0,
            TotalEarning: 0,
            TotalOrder: 0,
            ActiveStore: 0,
            alertMessage: '',
            flag: false,
            flag1: false,
            showLoading: true,
            storedata: [],
            storeTag: '',
            sheetsFlag: 0,
            step1RevStore: 0,
            step2RevStore: 0,
            step3RevStore: 0,
            step4RevStore: 0,
            selectedTab: '',
            uploadSpinner: false,
            fromDate: this.props.UpcommingSales.salefrom,
            toDate: this.props.UpcommingSales.saleto,
            storeSheetdata: ['Fee_Orders'],
            lastUpdatedOrders: ''
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadData() {
        let bodyData = {
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            showLocked: this.state.showLocked ? this.state.showLocked : false
        };

        await RestServices.getAllStoresEmailMappedWith(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (AllStoreTagsData) => {
                if (AllStoreTagsData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: AllStoreTagsData.error,
                            showLoading: false
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            TotalStoreAssigend: AllStoreTagsData.length,
                            alert: 0
                        });
                    }
                    if (AllStoreTagsData.length > 0) {
                        this.fetchStoreStatics(AllStoreTagsData);
                    } else {
                        if (this._isMounted) {
                            this.setState({ showLoading: false });
                        }
                    }
                }
            })

            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    async fetchStoreStatics(AllStoreTagsData) {
        let StoreRev = 0;
        let storeTagsData = [];
        let TotalTOV = 0;
        let TotalActiveStore = 0;
        let TotalOrder = 0;

        let bodyData = {
            storeTag: AllStoreTagsData,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        };
        
        await RestServices.fetchStoreStatics(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData) {
                    TotalActiveStore = responseData.length;

                    await responseData.forEach(async (storetag) => {
                        TotalTOV =
                            parseFloat(TotalTOV) +
                            parseFloat(storetag.OpsTotal);
                        TotalOrder = TotalOrder + storetag.OrderTotal;
                    });

                    if (this._isMounted) {
                        this.setState({ TotalOPSStore: TotalTOV });
                        this.setState({ TotalOrderStore: TotalOrder });
                        this.setState({ ActiveStore: TotalActiveStore });
                        this.setState({ showLoading: false });

                        
                    }
                }
            });
    }

    render() {
        return (
            <div>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <div>
                        <hr />
                    </div>
                </Row>

                <Row className="center_align">
                    <Col>
                        <h6>Total Stores Assigned</h6>
                        <h5>{this.state.TotalStoreAssigend}</h5>
                    </Col>
                    <Col>
                        <h6>No: of Active Stores</h6>
                        <h5>{this.state.ActiveStore}</h5>
                    </Col>
                    <Col>
                        <h6>Total TOV</h6>
                        <h5> {this.state.TotalOPSStore.toFixed(2)}</h5>
                    </Col>

                    <Col>
                        <h6>Total Orders</h6>
                        <h5> {this.state.TotalOrderStore}</h5>
                    </Col>

                    {this.state.ActiveStore > 0 && (
                        <Col>
                            <h6>Active Store Count % </h6>
                            <h5>
                                {(
                                    (this.state.ActiveStore /
                                        this.state.TotalStoreAssigend) *
                                    100
                                ).toFixed(2)}
                            </h5>
                        </Col>
                    )}

                    {this.state.ActiveStore == 0 && (
                        <Col>
                            <h6>Active Store Count % </h6>
                            <h5>0</h5>
                        </Col>
                    )}
                </Row>
                <div>
                    <hr />
                </div>
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(SalesSummary);
